import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, PRIMARY_OUTLET, NavigationEnd } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAIN_NAV, PROFILE_NAV } from '../../constants/navigation';
import { HttpService, DataService, LoaderService, UtilityService, AuthService, XchangeratesService, CorporateService } from '../../services';
import { SharedModule } from 'src/app/shared/shared.module';
import { filter, map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { AuthSystemComponent } from '../auth-system/auth-system.component';

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.scss']
})
export class AuthHeaderComponent implements OnInit {
  currency: any[] = [];
  selectedItem: any = "";
  currencySelected: any = null;
  isLoggedIn = false;
  hideLoginButton: boolean = false;
  balance = 0;
  showCurrency = false;

  @Output() menuToggle = new EventEmitter();
  toggleMenu() {
    this.menuToggle.emit();
  }
  constructor(private router: Router, public route: ActivatedRoute, public loaderService: LoaderService, public util: UtilityService,
    private snackbar: MatSnackBar, public http: HttpService, public title: Title,  private auth: AuthService, public X_change : XchangeratesService,
    public dialog: MatDialog, public COPT: CorporateService) {
      this.trackUrlChanges();
      this.COPT.isCorporateUser() &&
        this.COPT.isCorporateBalanceUser()
        .subscribe(res => this.balance = res?.user?.totalBalance ?? 0);
      this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateCurrencyVisibility(event.urlAfterRedirects);
      })
  }

  navItems = MAIN_NAV;
  profileItems = PROFILE_NAV;

  ngOnInit(): void {
    if (this.auth.loggedIn()) {
      this.isLoggedIn = true;
    } else {
      // this.isLoggedIn = false;
    }
    this.X_change.currency$.subscribe(active => {
      if (active) {
        this.currencySelected = active;
      }
    });
    const storedList = localStorage.getItem('currency_List');
    if (storedList) {
      try {
        this.currency = JSON.parse(storedList);
      } catch {}
    }
    this.X_change.currencyList();
  }

  signIn(){
    this.COPT.isCorporateUser()
      ? this.router.navigate(['registration'], { relativeTo: this.route })
      : this.dialog.open(AuthSystemComponent, { panelClass: 'customAuthDialog' });
    // this.router.navigate(['signIn'], { relativeTo: this.route });
  }

  getProfileImage() {
    const user = this.util.getTokenData();
  }
  profile() {
    this.router.navigate(['profile'], { relativeTo: this.route });
  }

  logOut() {
    this.util.logOutUser();
  }

  select(item: any) {
    this.currencySelected = item;
    this.X_change.pushCurrencyActive(item);
  }

  openVisa(): void {
    window.open("https://visa.cheapticket.in/", "_blank");
  }

  private trackUrlChanges() {
    const initialUrl = this.router.url;
    this.hideLoginButton = initialUrl.includes('_Payment') || initialUrl.includes('_add-ons') || initialUrl.includes('code');
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
      this.hideLoginButton = urlAfterRedirects.includes('_Payment') || urlAfterRedirects.includes('_add-ons') || initialUrl.includes('code');
    });
  }

  profile_image() {
    return JSON.parse(localStorage.getItem('Flight_User_Detiles') || 'null')?.profile_img || null;
  }

  private updateCurrencyVisibility(url: string) {
    this.showCurrency = ['/', '/flights']
    .includes((url = url.split('#')[0].replace(/^\/u/, ''))) ||
    url.startsWith('/flights/search');
  }
}
